import type { RouteObject } from 'react-router';

import { RequirePermission } from '@saniplus/ui';

import { PermissionFallback } from '../../components/shared/PermissionFallback';

/**
 * A16 / A17 / A18 — the organisation routes, exported for the app router to
 * mount. The feature owns its own paths so a route rename is one file, and the
 * integrator never has to know which component lives where.
 *
 * Two gates, because the section spans two permissions: contracts read
 * `contract:read`, sites read `site:read`, and a supervisor can hold one
 * without the other. Hiding the nav link is not enough — a typed URL or a
 * bookmark reaches the page anyway.
 *
 * Zones (A18) have no route of their own by design: they are edited inline on
 * the site they belong to, because a zone name without its plant is not a thing
 * anyone looks up. They ride the site's `site:read` gate for the same reason.
 */
export const routes: RouteObject[] = [
  {
    path: '/organisation/contrats',
    element: <RequirePermission permission="contract:read" fallback={<PermissionFallback />} />,
    children: [
      {
        index: true,
        lazy: async () => ({
          Component: (await import('./pages/ContractsPage')).ContractsPage,
        }),
      },
      {
        path: ':id',
        lazy: async () => ({
          Component: (await import('./pages/ContractDetailPage')).ContractDetailPage,
        }),
      },
    ],
  },
  {
    path: '/organisation/sites',
    element: <RequirePermission permission="site:read" fallback={<PermissionFallback />} />,
    children: [
      {
        index: true,
        lazy: async () => ({
          Component: (await import('./pages/SitesPage')).SitesPage,
        }),
      },
      {
        path: ':id',
        lazy: async () => ({
          Component: (await import('./pages/SiteWorkbenchPage')).SiteWorkbenchPage,
        }),
      },
    ],
  },
];
